import i18n from './i18n';
/**
 * 用于提示错误
 * @param {Object} res 
 * @returns {String}
 */
export function errorInfo(res) {
    const ErrorMap = {
        1: "失败",
        2: "参数错误",
        3: "未找到相关的数据",
        4: "用户名或密码错误",

        // "用户登录时间过期",
        5: i18n.t("Session_Expired_Message"),

        6: "你已在其它地方登录",
        // 7: "课程为完成",
        // 8: "重复的名字",
        // 9: "验证码错误",
        // 10: "验证码超时",
        // 11: "电话号码重复",
        // 12: "已存在数据不能删除",
        // 13: "服务器异常",
        // 14: "原始密码错误",
        // 15: "职位参数配置错误",
        // 16: "没有可以使用的数据",
        // 17: "传入的参数不完整",
        // 18: "文件为空",
        // 19: "不是excel",
        // 20: "数据异常",
        // 21: "数据异常",
        // 22: "例子存在",
        // 23: "7天后的时间大于结束时间",
        // 24: "结束时间小于今后的7天时间",
        // 25: "录入例子是老师",
        // 26: "班级正在上课中不能进行其他操作",
        // 27: "数据库存在重复的电话",
        // 28: "存在重复",
        // 29: "该行政单位已有领导",
        // 30: "不需要重复修改",
        // 31: "数据冲突",
        // 32: "相同数据冲突",
        // 33: "该职位无权操作",
        // 34: "领取例子数过多",
        // 35: "上次约课还未结束",
        // 36: "约课/排课数过多",
        // 37: "纸质发票",
        // 39: "视频大小超过上限",
        // 40: "图片大小超过上限",
        // 41: "用户已存在",
        // 42: "链接已失效",
        // 43: "用户不存在",
        // 44: "验证码过期",
        // 45: "学校代码不存在",
        46: i18n.t("用户名或密码错误，请确认后重新输入。"),
        48: "用户账号被禁用，详情请咨询ICode客服。",
        // 49: "游戏未开始",
        // 50: "游戏已结束",
        // 51: "玩家数据有误",
        // 52: "该学校已存在",
        // 53: "提示用邮箱登录",
        // 54: "该手机号已被多用户注册,提示用邮箱登录",
        // 55: "关卡重复提醒",
        // 56: "手机号存在和多个邮箱绑定的关系",
        // 57: "邮箱号存在多个绑定的关系",
        // 58: "缓存中数据缺失",
        // 59: "学校奖项已经申领",
        // 60: "学校名和手机号不对应",
        // 61: "该手机号已绑定过其他微信号",
        // 62: "需要绑定手机号",
        // 63: "该邮箱号已绑定过其他微信号",
        // 64: "该验证码已使用",
        // 65: "该玩家未获奖",
        // 66: "邮寄地址已填写",
        // 67: "优秀指导教师姓名已填写",
        // 68: "获奖的用户已经查询了成绩",
        // 69: "获奖的用户已经查询了成绩，但未填写邮寄地址",
        // 70: "没有该openId的用户",
        // 71: "获奖的用户已经查询了成绩，但未填写邮寄地址",
        // 72: "该查询的账号绑定多个学校",
        // 73: "该查询的手机号和该学校不对应",
        // 74: "该用户openId和该学校不对应",
        // 75: "游戏结果查询未开始",
        // 76: "游戏结果查询未开始",
        // 77: "游戏结果查询及奖项申领已结束",
        // 78: "用户未关注",
        // 79: "用户已关注公众号，但未领奖",
        // 80: "电子奖",
        // 81: "该微信已经绑定账户",
        // 82: "获取列表信息",
        // 83: "获取单独用户的过关信息",
        // 84: "重复请求",
        // 85: "输入的代码为空或玩家步数为空",
        // 87: "用户未有闯关信息",
        // 88: "不存在该用户信息",
        // 89: "信息格式输入有误",
        // 90: "跳关失败",
        // 91: "已达最高关卡",
        // 92: "闯关成功",
        // 93: "JSONWebToken解密出错",
        // 94: "jwtToken中sub缺失",
        // 95: "传入的游戏等级与用户数据不一致",
        // 96: "用户基本信息已过期",
        // 97: "用户基本信息有效-无法二次更新",
        // 98: "传入的游戏模式与用户所选模式不一致",
        // 99: "修改学校-旧学校已有编码",
        // 100: "修改学校-新学校无编码",
        // 101: "不能参加决赛-非金奖",
        // 102: "不能参加决赛-年级不符",
        // 103: "不能参加决赛-不在报名开放时间段",
        // 104: "不能下载准考证-不在下载开放时间段",
        105: "很抱歉，这个活动仅向正式宇航员开放",
        // 106: "用户竞赛、教材等级不够",
        // 107: "商品不存在",
        // 108: "机构过期账号需要绑定手机号",
        // 109: "操作需要为老师",
        // 110: "没有决赛资格",
        // 111: "用户周赛时间已超时",
        // 112: "未插入比赛时间数据",
        // 113: "晋级赛正在更新，请稍后再进",
        // 114: "兑换码已被使用",
        // 115: "兑换码已过期",
        // 116: "兑换码错误",
        // 117: "一年以上会员不允许兑换",
        // 118: "邀请人手机号错误，请检查邀请人手机号",
        // 119: "渠道方的游戏只有渠道方用户才可以玩",
        // 120: "活动不存在或被关闭",
        // 121: "活动比赛不存在",
        // 122: "比赛不存在",
        // 123: "没有配置开始或结束时间",
        // 124: "ip不在白名单中",
        // 125: "奇思智鱼比赛只向vip用户开放",
        // 临时证书已存在  126
        // 手机号格式错误  127
        // 渠道码错误  128
        // 只有机构方才能登陆  129
        // 重复报名  130
        // 重复点击  131
        // 排行版暂不显示  132
        // 使用了不规范的代码  133
        // 身份证号错误  134
        // 身份证号重复  135
        // 头像id错误  136
        // 比赛密码错误  137
        // 未报名决赛  138
        // 用户没有签到  139
        // 您有未完成的关卡  140
        // 报名已关闭  141
        //  图形化验证码错误 */ 142
        // 143: "机构课程已经过期",
        17:  "无效的请求参数，请重新登录后尝试。如果一直出现该提示，请反馈给ICode管理员。",
        49:  "活动还未开始，请耐心等待。如果活动时间不正确，请反馈给ICode管理员。",
        50:  "活动已经结束了，请下次再来吧。如果活动时间不正确，请反馈给ICode管理员。",
        111: "本活动为个人限时活动(60分钟)，您的已经完成了活动。注意：活动时间是从首次进入答题页面开始算起",
        119: "您的账号暂未获得参加该活动的资格，详情请咨询活动主办方。",

        // 账号暂未获得参加该活动的资格，详情请咨询活动主办方。
        120: i18n.t("You are not eligible to register. For more details, please contact the event organizer."), 

        122: "活动不存在，请反馈给ICode管理员。",
        123: "活动配置信息错误，请反馈给ICode管理员。",
    }
    
    return ErrorMap[res.code] || res.msg;
}




// WEBPACK FOOTER //
// ./src/utils/error.js